import { message } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import React from "react";
import { injectIntl } from "react-intl";

class FeedbackMessage extends React.Component {
  componentDidUpdate(prevProps) {
    const { message: newMessage, type, notificationKey } = this.props;
    const { notificationKey: prevNotificationKey } = prevProps;

    // Check if the notificationKey has changed
    if (notificationKey !== prevNotificationKey) {
      switch (type) {
        case "success":
          message.success(this.props.intl.formatMessage({ id: newMessage }));
          break;
        case "error":
          message.error(this.props.intl.formatMessage({ id: newMessage }));
          break;
        case "info":
          message.info(this.props.intl.formatMessage({ id: newMessage }));
          break;
        case "warning":
          message.warning(this.props.intl.formatMessage({ id: newMessage }));
          break;
        default:
          message.info(this.props.intl.formatMessage({ id: newMessage }));
      }
    }
  }
  render() {
    return null;
  }
}

const mapStateToProps = store => ({
  message: store.feedbackMessage.message,
  type: store.feedbackMessage.type,
  notificationKey: store.feedbackMessage.notificationKey
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators({}, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(FeedbackMessage));
